function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 25l10-8m-13 3l10-8M8 15l10-8",
  stroke: "#0085FF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#0085FF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  cx: 16,
  cy: 16,
  r: 15
}));
function SvgDashboardBlueBusiness(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _ref);
}
export default SvgDashboardBlueBusiness;